<template>
  <div id="tablePage">
    <!-- 出库申请仓单查询 -->
    <div class="orderTable">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        @sort-change="sortChange"
        v-loading="loading"
      >
        <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <!-- <el-table-column
          prop="pickId"
          label="出库编号"
        >
        </el-table-column> -->
        <el-table-column
          prop="warehouseId"
          label="仓单号"
        >
        </el-table-column>
        <el-table-column
          prop="commodityName"
          label="商品名称"
          min-width="100"
        >

        </el-table-column>
        <el-table-column
          prop="pickQuantity"
          label="商品数量"
        >
        </el-table-column>
        <el-table-column
          prop="weight"
          label="商品总重量"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="仓库名称"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="unitQuantifier"
          label="单位"
        >
        </el-table-column>
        <el-table-column
          prop="warehouseType"
          label="仓单类型"
        >
        </el-table-column> -->
        <el-table-column
          prop="pickType"
          label="出库方式"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.pickType=='Z'?'自提':'物流' }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="responsibleName"
          label="联系人"
        >
        </el-table-column>
        <el-table-column
          prop="deliveryCard"
          label="提货人身份证号"
        >
        </el-table-column> -->
        <el-table-column
          prop="pickNo"
          label="提货密钥"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="responsiblePhone"
          label="联系人电话"
        >
        </el-table-column>
        <el-table-column
          prop="postCode"
          label="邮编"
        >
        </el-table-column>
        <el-table-column
          prop="address"
          label="收货地址"
        >
        </el-table-column> -->
        <el-table-column
          prop="createTime"
          label="提货单开具日期"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.createTime | dateFormateDay }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="最后提货日"
        >
          <template slot-scope="scope">
            <span> 最后交收日后第三天 </span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="deliveryFee"
          label="配送费"
        >
        </el-table-column>
        <el-table-column
          prop="pickStatus"
          label="出库状态"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.pickStatus | deliveryStatus }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="createTime"
          label="操作"
        >
          <template slot-scope="scope">
            <span class="operation" @click="showBillOfLoading(scope.row)"> 查看提货单</span>
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <!-- 提货单 -->
    <BillOfLoading :dialog-visible="dialogVisibleDelivery" :delivery-id="deliveryId" @boolChange="switchBoolDelivery"></BillOfLoading>
  </div>
</template>
<script>
/*global http protocol*/
import { mapGetters } from 'vuex'
import BillOfLoading from '@/components/base/billOfLoading/BillOfLoading'
export default {
  components: {
    BillOfLoading
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['warehouseId', 'isSearch'],
  data() {
    return {
      tableHeight: 0,
      loading: false,
      checked: false,
      tableData: [],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      // 表格label宽度
      tcdTableWidth: {
        bsFlag: 80,
        ocFlag: 110,
        closePl: 100
      },
      TradeListSum: {
        'bsFlag': '',
        'closePl': 0,
        'commodityCode': '',
        'commodityId': 0,
        'commodityName': '',
        'createTime': 0,
        'fee': 0,
        'firmId': 0,
        'holdDetailId': 0,
        'margin': 0,
        'ocFlag': '',
        'orderId': 0,
        'quantity': 0,
        'singlePrice': 0,
        'tqTip': 0,
        'tradeDay': 0,
        'tradeId': 0,
        'tradeType': 0,
        'updateTime': 0,
        'stampFee': 0
      },
      isNetWrong: false,
      /** 提货单 start */
      deliveryId: null,
      dialogVisibleDelivery: false
      /** 提货单 end */
    }
  },

  computed: {
    ...mapGetters(['sessionInfoGetter'])
  },
  watch: {
    isSearch(val) {
      if (val) {
        this.pageData.currentPage = 1
        this.showData()
      }
    }
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  mounted() {
    this.showData()
  },
  methods: {
    // item 提货记录信息
    showBillOfLoading(item) {
      this.deliveryId = item.pickId
      this.dialogVisibleDelivery = true
    },
    // 接受提货单的通信事件(确定或取消)
    switchBoolDelivery(message) {
      this.dialogVisibleDelivery = false
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      this.loading = true
      const params = JSON.parse(JSON.stringify(protocol.param_getPickList))
      params.data = {}
      params.data.page =
          this.pageData.currentPage - 1
      params.data.size =
          '' + this.pageData.pageSize
      params.data.firmId = this.sessionInfoGetter.firmId
      params.data.pickStatus = 'W'
      params.data.pickType = 'Z'
      params.data.warehouseId = this.warehouseId // 搜索仓单号
      params.data.sort = [
        {
          direction: 'DESC', // "//DESC或ASC",
          property: 'pickId' // "//排序属性"
        }
      ]
      http.gPost(params).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.judgeDataType(arr)
          }
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
        setTimeout(() => {
          that.showData()
        }, 1000)
      })
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        // 判断时间
        // that.modifyTime(arrIndex, 'createTime')
        // that.modifyTime(arrIndex, 'updateTime')
        // 判断方向
        that.modifyData(arrIndex, 'bsFlag', 'B', '买入', '卖出')
        that.modifyData(arrIndex, 'ocFlag', 'O', '订立', '转让')
      })
      this.tableData = arr
    },
    // 排序
    sortChange(column, prop, order) {
      if (column.order == 'ascending') {
        protocol.queryUserClinches.data.sort[0].direction = 'ASC'
      } else {
        protocol.queryUserClinches.data.sort[0].direction = 'DESC'
      }
      // protocol.queryUserClinches.data.firmId = this.sessionInfoGetter.firmId
      if (column.column) {
        this.eachSortChange(column.column.property)
        http.gPost(protocol.queryUserClinches).then(response => {
          if (response.data.code != 0) {
            this.$message({ message: response.data.message })
            this.isNetWrong = true
          } else {
            this.isNetWrong = false
          }
          if (response.data) {
            if (response.data && response.data.code == '0') {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.TradeListSum = response.data.value.sumData
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      return (protocol.queryUserClinches.data.sort[0].property = str)
    },
    // 合计
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const that = this
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 3) {
          sums[index] = '共' + this.pageData.total + '条'
          return
        }
        if (index === 7) { // 成交数量
          sums[index] = that.TradeListSum.quantity
          return
        }
        if (index === 8) { // 成交金额
          sums[index] = that.TradeListSum.funds
          return
        }
        // if (index === 10) { // 转让存货价
        //   sums[index] = that.TradeListSum.fee
        //   return
        // }
        if (index === 10) { // 利润
          sums[index] = that.TradeListSum.closePl
          return
        }
        if (index === 11) { // 印花税
          sums[index] = that.TradeListSum.stampFee
          return
        }
        if (index === 12) { // 手续费
          sums[index] = that.TradeListSum.fee
          return
        }
        sums[index] = ''
      })
      return sums
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale = localStorage.lang || navigator.language.slice(-2).toLowerCase()
      switch (localStorage.lang) {
        case 'en': {
          const tcdTableEnWidth = {
            bsFlag: 120,
            ocFlag: 150,
            closePl: 150
          }
          localStorage.setItem('tcdTableEnWidth', JSON.stringify(tcdTableEnWidth))
          this.tcdTableWidth = JSON.parse(localStorage.tcdTableEnWidth)
        }
          break
        default:
          break
      }
    }

  }

}
</script>
